import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Collapse } from "reactstrap"
import { getProviderToProviderPendingCount } from "store/provider-dashboard/provider-dashboard-action"
import { getTotalExpireReceiptsCount } from "store/provider-exipre-receipts/e-expire-receipts-action"
import { getProviderStockOutCount } from "store/provider-stock-out/provider-stockout-action"
import { getProvinceActionRequestCount } from "store/province-action-requests/province-action-request-action"
import ProtectedMenuItem from "components/Common/ProtectedMenuItem"
import { PERMISSIONS } from "utils/permissionConfig"

const ProviderNavbar = props => {
  const [report, setReport] = useState(false)
  const [expireList, setExpireList] = useState(false)
  const [items, setItems] = useState(false)
  const [systemSetup, setSystemSetup] = useState(false)

  const dispatch = useDispatch()

  const totalExpireCount = useSelector(
    state => state.providerExpireReceipts.count
  )
  const totalStockOut = useSelector(state => state.providerStockout.count)
  const totalRFA = useSelector(
    state => state.provinceActionRequest.ActionRequestCount.distribution
  )
  const totalPendingProviderToProvider = useSelector(
    state => state.providerDashboard.providerToProviderPendingCount
  )

  useEffect(() => {
    dispatch(getTotalExpireReceiptsCount())
    dispatch(getProviderStockOutCount())
    dispatch(getProvinceActionRequestCount())
    dispatch(getProviderToProviderPendingCount())
  }, [])

  return (
    <Collapse
      isOpen={props.leftMenu}
      className="navbar-collapse"
      id="topnav-menu-content"
    >
      <ul className="navbar-nav">
        <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVIDER_IN}>
          <li className="nav-item ">
            <Link className="nav-link " to="/provider-receipts">
              <i className="bx bx-home-circle me-2"></i>
              Receipts ( In )
              <span style={{ color: "green" }}>
                {" "}
                {totalPendingProviderToProvider != 0 &&
                  `( ${totalPendingProviderToProvider} )`}
              </span>
            </Link>
          </li>
        </ProtectedMenuItem>
        <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVIDER_OUT}>
          <li className="nav-item ">
            <Link className="nav-link " to="/provider-distributions">
              <i className="bx bx-home-circle me-2"></i>
              Distributions ( Out )
            </Link>
          </li>
        </ProtectedMenuItem>
        <li className="nav-item dropdown">
          <Link
            className="nav-link dropdown-toggle arrow-none"
            onClick={e => {
              e.preventDefault()
              setExpireList(!expireList)
            }}
            to="#"
            style={
              totalExpireCount?.countPerMonth > 0 ||
              totalExpireCount?.countPerYear > 0
                ? { color: "red" }
                : {}
            }
          >
            <i className="mdi mdi-order-bool-descending me-2"></i>
            Expire Lists{props.menuOpen}
            <div className="arrow-down"></div>
          </Link>
          <div className={"dropdown-menu"}>
            <Link to="/provider-expire-receipts" className="dropdown-item">
              Expire List / 6 Month &nbsp;
              <span className="text-danger" style={{ fontSize: 11 }}>
                ( {totalExpireCount?.countPerMonth} )
              </span>
            </Link>

            <Link
              to="/provider-expire-receipts-base-12-month"
              className="dropdown-item"
            >
              Expire List / 12 Month &nbsp;
              <span className="text-danger" style={{ fontSize: 11 }}>
                ( {totalExpireCount?.countPerYear} )
              </span>
            </Link>
          </div>
        </li>
        <ProtectedMenuItem permission={PERMISSIONS.SHOW_CONSUMPTION}>
          <li className="nav-item ">
            <Link className="nav-link " to="/provider-consumptions">
              <i className="bx bx-home-circle me-2"></i>
              Consumptions
            </Link>
          </li>
        </ProtectedMenuItem>
        <li className="nav-item ">
          <Link className="nav-link " to="/provider-stock-out">
            <i className="bx bx-home-circle me-2"></i>
            Stock Out &nbsp;
            <span className="text-danger" style={{ fontSize: 11 }}>
              ( {totalStockOut} )
            </span>
          </Link>
        </li>
        <li className="nav-item ">
          <Link className="nav-link " to="/dashboard">
            <i className="bx bx-home-circle me-2"></i>
            Dashboard
          </Link>
        </li>

        <ProtectedMenuItem
          permission={[
            PERMISSIONS.SHOW_WAREHOUSE,
            PERMISSIONS.SHOW_PROJECT,
            PERMISSIONS.SHOW_PROVIDER,
            PERMISSIONS.SHOW_PROVINCE,
            PERMISSIONS.SHOW_CURRENCY,
            PERMISSIONS.SHOW_FACILITY,
            PERMISSIONS.SHOW_IP,
          ]}
          permissionLogic="any"
        >
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setSystemSetup(!systemSetup)
              }}
              to="#"
            >
              <i className="mdi mdi-cog me-2"></i>
              System Setup {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_WAREHOUSE}>
                <Link to="/warehouse" className="dropdown-item">
                  <i className="mdi mdi-warehouse me-2"></i>
                  Warehouse
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROJECT}>
                <Link to="/projects" className="dropdown-item">
                  <i className="mdi mdi-order-bool-descending me-2"></i>
                  Project
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVIDER}>
                <Link to="/providers" className="dropdown-item">
                  <i className="mdi mdi-order-bool-descending me-2"></i>
                  Providers
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVINCE}>
                <Link to="/provinces" className="dropdown-item">
                  <i className="mdi mdi-google-maps me-2"></i>
                  Province
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_CURRENCY}>
                <Link to="/currencies" className="dropdown-item">
                  <i className="mdi mdi-currency-usd me-2"></i>
                  Currency
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_FACILITY}>
                <Link to="/facilities" className="dropdown-item">
                  <i className="mdi mdi-home me-2"></i>
                  Facilities
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_IP}>
                <Link to="/ips" className="dropdown-item">
                  <i className="mdi mdi-account-group me-2"></i>
                  IPs
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>

        <ProtectedMenuItem
          permission={[PERMISSIONS.SHOW_ITEM_CATEGORY, PERMISSIONS.SHOW_ITEM]}
          permissionLogic="any"
        >
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setItems(!items)
              }}
              to="#"
            >
              <i className="mdi mdi-order-bool-descending me-2"></i>
              Items {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ITEM_CATEGORY}>
                <Link to="/item-categories" className="dropdown-item">
                  Item Category
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ITEM}>
                <Link to="/items" className="dropdown-item">
                  Item
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>

        <ProtectedMenuItem permission={PERMISSIONS.SHOW_REPORT}>
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setReport(!report)
              }}
              to="#"
            >
              <i className="mdi mdi-order-bool-descending me-2"></i>
              Reports {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <Link to="/provider-transactions" className="dropdown-item">
                All Transactions ( In / Out )
              </Link>
              <Link
                to="/provider-transactions-by-project"
                className="dropdown-item"
              >
                All Transactions ( In / Out ) By Project
              </Link>
              <Link to="/provider-receipt-reports" className="dropdown-item">
                Receipts ( In )
              </Link>
              <Link
                to="/provider-distribution-reports"
                className="dropdown-item"
              >
                Distributions ( Out )
              </Link>
              <Link
                to="/provider-ip-distribution-reports"
                className="dropdown-item"
              >
                IP Distributions ( Out )
              </Link>
              <Link to="/provider-inventory-reports" className="dropdown-item">
                Inventory
              </Link>
              <Link
                to="/provider-consumptions-reports-second"
                className="dropdown-item"
              >
                Consumptions
              </Link>
              <Link
                to="/provider-receipt-health-reports"
                className="dropdown-item"
              >
                Receipt Health ( In )
              </Link>
              <Link
                to="/provider-quantification-report"
                className="dropdown-item"
              >
                Quantification Report
              </Link>
              <Link
                to="/provider-quantification-based-organization-report"
                className="dropdown-item"
              >
                Quantification Based Organization Report
              </Link>
              <Link to="/provider-me-report" className="dropdown-item">
                M&E Report
              </Link>
            </div>
          </li>
        </ProtectedMenuItem>

        <li className="nav-item dropdown">
          <Link
            className="nav-link dropdown-toggle arrow-none"
            onClick={e => {
              e.preventDefault()
              setReport(!report)
            }}
            to="#"
          >
            <i className="mdi mdi-order-bool-descending me-2"></i>
            Others {props.menuOpen}
            <div className="arrow-down"></div>
          </Link>
          <div className={"dropdown-menu"}>
            <Link to="/provider-transfer-to-facility" className="dropdown-item">
              Transfer to Facility
            </Link>
            <ProtectedMenuItem permission={PERMISSIONS.SHOW_RETURNED_ITEMS}>
              <Link to="/provider-returned-items" className="dropdown-item">
                Re-allocation Items
              </Link>
            </ProtectedMenuItem>
            <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVIDER_TRANSFER}>
              <Link to="/provider-transfers" className="dropdown-item">
                Transfer History
              </Link>
            </ProtectedMenuItem>
            <Link className="dropdown-item">
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ADJUSTMENT}>
                <Link className="" to="/provider-adjustments">
                  Adjustments
                </Link>
              </ProtectedMenuItem>
            </Link>
            <Link
              className="dropdown-item"
              to="/provider-province-action-request"
            >
              RFA &nbsp;{" "}
              <span className="text-danger" style={{ fontSize: 11 }}>
                ( {totalRFA} )
              </span>
            </Link>
          </div>
        </li>
      </ul>
    </Collapse>
  )
}

export default ProviderNavbar
